export default (props) => (
  <svg
    width="193"
    height="49"
    viewBox="0 0 193 49"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    {...props}
  >
    <title>Axios logo</title>
    <path d="M102.237 1.54102V47.187H90.9011V1.54102H102.237Z" fill="#222222" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M154.975 24.276C154.975 10.603 144.039 0.0840454 130.462 0.0840454C116.886 0.0840454 105.71 10.7791 105.726 24.4521C105.726 38.1411 116.741 48.724 130.35 48.724C143.959 48.724 154.975 37.997 154.975 24.276ZM142.855 24.356C142.855 31.3526 137.572 37.5807 130.367 37.5807C123.178 37.5807 117.847 31.3526 117.847 24.356C117.847 17.3594 123.162 11.1954 130.367 11.1954C137.539 11.1954 142.855 17.3594 142.855 24.356Z"
      fill="#222222"
    />
    <path
      d="M156.272 33.3859L166.663 30.9203C167.415 36.4119 171.402 38.3812 175.597 38.3812C179.76 38.3812 181.281 35.9156 181.281 33.9943C181.281 32.4413 180.384 30.9203 177.342 30.3119L171.002 29.0791C163.413 27.6221 158.049 22.851 158.049 15.5182C158.049 6.79245 166.006 0.644409 174.988 0.644409C186.564 0.644409 191.335 7.88117 192.168 13.9331L181.969 16.799C181.425 13.0686 179.119 10.3628 174.94 10.3628C171.322 10.3628 169.593 12.7804 169.593 14.6056C169.593 16.1266 170.313 17.8717 173.003 18.4001L179.615 19.6649C188.261 21.33 193 26.6135 193 33.482C193 40.9429 186.564 48.1316 175.533 48.1316C163.989 48.1476 157.793 42.0957 156.272 33.3859Z"
      fill="#222222"
    />
    <path
      d="M13.0734 47.187H0.873413L21.0147 1.54102H33.2467L13.0734 47.187Z"
      fill="#222222"
    />
    <path
      d="M72.9689 23.8597L88.1149 1.52496H74.2658L66.0844 15.0378L58.1112 1.52496H44.0699L59.408 23.8597L49.4975 38.3812L33.2468 1.54097H21.0148L41.2361 47.187H56.5421L66.0844 32.7295L75.5306 47.187H88.0508L72.9689 23.8597Z"
      fill="#222222"
    />
  </svg>
)
